import React from 'react'
import mParticleSdk from '@mparticle/web-sdk'
import { buildMParticleGlobalProperties, useInternalAnalytics } from '.'
import type { PurchaseCookieDto } from 'models/purchase'
import type { PageConfig } from 'models/pages'

// * mParticle logPurchase event
export const useMParticleLogPurchase = (
  pageConfig: PageConfig,
  loggedInState: boolean,
  purchaseCookie?: PurchaseCookieDto,
) => {
  const { mParticle, consentSynced } = useInternalAnalytics()

  React.useEffect(() => {
    if (
      !mParticle ||
      !consentSynced ||
      !purchaseCookie ||
      // * Only fire purchase event if purchaseCookie exists
      // * and the purchase event has not been sent.
      !!sessionStorage.getItem(`purchase_${purchaseCookie.id}_sent`) ||
      // do not fire mParticle purchase event for cart purchases
      pageConfig.isCartEnabled
    )
      return

    const globalProperties = buildMParticleGlobalProperties(mParticle, loggedInState)

    // * Setup a product for mParticle eCommerce actions
    const product = mParticle.eCommerce.createProduct(
      'Donation',
      pageConfig.campaignId,
      // note: does not exist on cart transaction cookie
      purchaseCookie.donation_gross_amount,
      1,
      undefined,
      'other',
    )

    // * Log mParticle eCommerce event with simple donation product
    mParticle.eCommerce.logProductAction(
      mParticleSdk.ProductActionType.Purchase,
      product,
      {
        ...globalProperties,
        Id: purchaseCookie.id,
        Revenue: purchaseCookie.donation_gross_amount,
        Tax: 0,
      },
      {
        'GA4.Title': document.title,
        'GA4.Location': document.location.href,
        'GA4.Referrer': document.referrer,
      },
    )

    // * Set a session storage value after purchase event
    sessionStorage.setItem(`purchase_${purchaseCookie.id}_sent`, 'true')
  }, [consentSynced, loggedInState, mParticle, pageConfig, purchaseCookie])
}
